import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgInboxIn = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	fill: "none",
	"xmlns:v": "https://vecta.io/nano",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#A)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M14 8h-2c-.735 0-1.333.598-1.333 1.333s-.598 1.333-1.333 1.333H6.667c-.735 0-1.333-.598-1.333-1.333S4.735 8 4 8H2c-1.103 0-2 .897-2 2v2.667A3.34 3.34 0 0 0 3.333 16h9.333A3.34 3.34 0 0 0 16 12.667V10c0-1.103-.897-2-2-2zm.667 4.667c0 1.103-.897 2-2 2H3.333c-1.103 0-2-.897-2-2V10c0-.368.299-.667.667-.667l2-.001v.001A2.67 2.67 0 0 0 6.667 12h2.667A2.67 2.67 0 0 0 12 9.333h2c.368 0 .667.299.667.667v2.667zM4.862 4.747c-.261-.261-.261-.682 0-.943s.682-.261.943 0l1.529 1.529V.667C7.333.298 7.631 0 8 0s.667.298.667.667v4.667l1.529-1.529c.261-.261.682-.261.943 0s.261.682 0 .943L8.943 6.943a1.33 1.33 0 0 1-.937.389L8 7.333l-.006-.001a1.33 1.33 0 0 1-.937-.389L4.862 4.747z",
			fill: "#333"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "A",
		children: /* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "M0 0h16v16H0z"
		})
	}) })]
});
export default SvgInboxIn;
